var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlinkedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 181,
    viewBox: "0 0 182 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.8888,
    cy: 90.6271,
    r: 90.3361,
    fill: "#3AE180"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7153 92.9718L73.0347 119.858L130.405 63.3975",
    stroke: "white",
    strokeWidth: 16.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkedCheck);
export default __webpack_public_path__ + "static/media/unlinked_check.b8421cd66dfb8635bcad7cbca2e69918.svg";
export { ForwardRef as ReactComponent };